export default __webpack_public_path__ + "media/src/assets/images/not_available-ba5c00402c648df60bb04bff1cac85cb.png";